module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user text-dark"
  }, [(!_vm.user && !_vm.calendar) ? _c('Loader', {
    staticStyle: {
      "margin-top": "200px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isSubHeader) ? _c('div', {
    staticClass: "sub-header"
  }, [_c('p', {
    staticClass: "sub-header__title"
  }, [_vm._v("\n      " + _vm._s(_vm.theSelectedUser.name) + "\n      "), _c('span', {
    staticClass: "sub-header__title-divider icon-arrow-right4"
  })]), _vm._v(" "), _c('a', {
    class: {
      'active': _vm.theView === 'calendar'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setTheView('calendar')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.calendar')))]), _vm._v(" "), (_vm.canSeeTaskOverview) ? _c('a', {
    class: {
      'active': _vm.theView === 'tasks'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setTheView('tasks')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.task_overview')))]) : _vm._e(), _vm._v(" "), (_vm.canSeeHourOverview) ? _c('a', {
    class: {
      'active': _vm.theView === 'hours'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.setTheView('hours')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.task_overview.hour_overview')))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeInUp"
    }
  }, [(_vm.user && _vm.calendar && _vm.theView === 'tasks') ? _c('TaskOverviewPage', {
    staticClass: "marg-1-top",
    attrs: {
      "isCanSeeOtherUsers": false,
      "user_id": _vm.theSelectedUser.userId,
      "user_calendar_id": _vm.theSelectedUser.calendarId,
      "user_name": _vm.theSelectedUser.name
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeInUp"
    }
  }, [(_vm.user && _vm.calendar && _vm.theView === 'hours') ? _c('UserTasks', {
    staticClass: "marg-1-top",
    attrs: {
      "isCanSeeOtherUsers": false,
      "user_id": _vm.theSelectedUser.userId,
      "user_calendar_id": _vm.theSelectedUser.calendarId,
      "user_name": _vm.theSelectedUser.name
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeInUp"
    }
  }, [(_vm.user && _vm.calendar && _vm.theView === 'calendar') ? _c('div', [_c('week-selector', {
    attrs: {
      "startDate": _vm.weekSelectorStartDate,
      "endDate": _vm.weekSelectorEndDate,
      "date": _vm.activeCalendarDate
    },
    on: {
      "changed": _vm.setDate
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "printCalendar"
    }
  }, [_c('div', {
    staticClass: "user-calendar"
  }, [_c('div', {
    staticClass: "user-calendar__header"
  }, [_c('div', {
    staticClass: "user-calendar__header__left"
  }, [_c('SelectCalendar', {
    staticClass: "marg-1-right",
    attrs: {
      "isMultiple": _vm.userHasPermission('can_see_other_calendars')
    }
  }), _vm._v(" "), (_vm.isUsersCalendar) ? _c('UserPresence', {
    attrs: {
      "calid": _vm.user.user_calendar_id,
      "activeCalendarDate": _vm.activeCalendarDate
    },
    on: {
      "saved": _vm.presenceCall
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "user-calendar__header__right"
  }, [(_vm.userCanRequestAbsence) ? _c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        _vm.isShowAbsenceRequest = true
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('vue2.request_absence.request_absence')) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('Print', {
    attrs: {
      "onlyPrintThisCalendar": true,
      "calendarId": _vm.theActiveCalendarId,
      "activeCalendarDate": _vm.activeCalendarDate
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "do-bttn no-print",
    class: {
      'bttn--disabled': _vm.isNotThisWeek
    },
    on: {
      "click": _vm.today
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('repitition.today')) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn icon-arrow-left4 no-print",
    on: {
      "click": _vm.prevWeek
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        animateFill: false,
        animation: 'shift-away',
        zIndex: '999999992',
        boundary: 'window',
        onShow: function () { return _vm.isAtMaxWeek; }
      }),
      expression: "{\n                arrow: true,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => isAtMaxWeek\n                }"
    }],
    attrs: {
      "content": _vm.isAtMaxWeek ? _vm.$t('vue2.calendar_view.next_week_disabled_tooltip') : ''
    }
  }, [_c('button', {
    staticClass: "do-bttn icon-arrow-right4 no-print",
    class: {
      'bttn--disabled': _vm.isAtMaxWeek
    },
    attrs: {
      "disabled": _vm.isAtMaxWeek
    },
    on: {
      "click": _vm.nextWeek
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "d-calendar__calendar__container",
    class: {
      'd-calendar__calendar__container--print-mode': _vm.isCalendarInPrintMode
    }
  }, [_c('DCalendar', {
    attrs: {
      "isEditable": _vm.isEditable,
      "isCalendarInPrintMode": _vm.isCalendarInPrintMode,
      "isShowWeekends": _vm.isShowWeekends,
      "startTime": _vm.startTime,
      "endTime": _vm.endTime,
      "date": _vm.activeCalendarDate,
      "events": _vm.dCalendarEvents,
      "calendarId": _vm.calendar.id,
      "calendarName": _vm.calendar.name,
      "isEventsClickable": true,
      "isLoadingEvents": _vm.isEventsLoading
    },
    on: {
      "onEventClick": _vm.setActiveEvent
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "user-calendar__footer no-print"
  }, [(_vm.isUsersCalendar) ? _c('ExportCalendar', {
    attrs: {
      "calLink": _vm.iCalUrl
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.isShowWeekPlan) ? _c('DWeekplan', {
    attrs: {
      "isInPrintMode": _vm.isInPrintMode,
      "isReadOnly": _vm.isInPrintMode || !_vm.userHasPermission('can_edit_own_notes')
    }
  }) : _vm._e()], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "zoomIn"
    }
  }, [(_vm.activeEvent) ? _c('DCalendarShowEvent', {
    attrs: {
      "canEditEvent": _vm.isEditable,
      "canEditNotes": _vm.userHasPermission('can_edit_own_notes'),
      "event": _vm.activeEvent,
      "calendar": _vm.calendar,
      "initCalendarId": _vm.calendar.id,
      "isInDCalendar": true
    },
    on: {
      "updated": _vm.readEvents,
      "close": _vm.closeShowEvent
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.isShowAbsenceRequest) ? _c('UserRequest', {
    on: {
      "close": function($event) {
        _vm.isShowAbsenceRequest = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-02f6ec14!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendars/CalendarView.vue
// module id = 1731
// module chunks = 1